/**
* @Author: Michael Neumair <mBook>
* @Date:   2016-08-22T13:39:18+02:00
* @Email:  7q7w7e7r@gmail.com
* @Last modified by:   mBook
* @Last modified time: 2016-08-30T14:30:56+02:00
*/

import React, {Component} from 'react';
import PropTypes from 'prop-types';
import buttonProps from './../../../utilities/buttonProps';

/**
 * AButtonYear - used in datepicker for year control
 */
class AButtonYear extends Component {
  /**
     * react render() <AButtonYear>
     *
     * @return {object}
     */
  render() {
    const {
      year,
      onPress, // eslint-disable-line no-unused-vars
      active, // eslint-disable-line no-unused-vars
      visualState,
      ...other
    } = this.props;

    const currentYearClass = year === new Date().getFullYear() ? 'current-year' : '';

    return (
      <a
        {...other}
        className={`a-button a-button-year ${visualState} ${currentYearClass}`}
        onClick={this.handleOnPress}
      >
        <span className="a-button-year__label">{year}</span>
      </a>
    );
  }

    /**
     * @param  {object} event
     */
    handleOnPress = (event) => {
      if (this.props.onPress) this.props.onPress(this.props.year, event);
    };
}
AButtonYear.propTypes = {
  /**
    * The css class name of the root element.
    */
  onPress: PropTypes.func,
  active: PropTypes.bool, // passed by buttonProps
  year: PropTypes.number,
  visualState: PropTypes.string, // passed by buttonProps
};
AButtonYear.defaultProps = {};
export default buttonProps(AButtonYear);

